/**
 * @desc 事件处理-关闭
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: Array<number>,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/wap/personal/event/close',
    data,
  });
}

export function mock(data: Array<number>): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/wap/personal/event/close',
    data,
  });
}
